import { render, staticRenderFns } from "./SpaceInvaders.vue?vue&type=template&id=840d6a82&scoped=true&"
import script from "./SpaceInvaders.vue?vue&type=script&lang=js&"
export * from "./SpaceInvaders.vue?vue&type=script&lang=js&"
import style0 from "./SpaceInvaders.vue?vue&type=style&index=0&id=840d6a82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840d6a82",
  null
  
)

export default component.exports